import { render } from "./DetailHistoryMapping.vue?vue&type=template&id=2f6a7c25"
import script from "./DetailHistoryMapping.vue?vue&type=script&lang=js"
export * from "./DetailHistoryMapping.vue?vue&type=script&lang=js"
script.render = render

export default script